/*
  industrialkonzept Next: share a product as a story (snippets/ik-product-story.liquid), 2026-09-23.
  "Share as story" sits with the other product tools (Will it fit? · In your room · Save to board), for
  everyone who likes the piece, not only for us. A tap draws a calm 9:16 picture (1080 × 1920) here in the
  browser: the chosen variant on a light grey, brand and designer, name, variant, price, "Available at …",
  free room for Instagram's link sticker and the logo in black. Nothing is stored anywhere and every product
  gets its picture by itself. Phones: share sheet with picture and link; computers: a window with the picture, "Save picture" and "Copy link" (window.ikStoryPreview in ik-lab.js).
*/
(() => {
  const el = document.querySelector('[data-ikp-story]');
  if (!el) return;
  let data;
  try {
    data = JSON.parse(el.textContent);
  } catch (e) {
    return;
  }
  const T = (k, v) => (window.ikT ? window.ikT(k, v) : k);
  const abs = (u) => (u && u.startsWith('//') ? 'https:' + u : u || '');

  const draw = async (p, v) => {
    const W = 1080, H = 1920, M = 84;
    const load = (src) => new Promise((ok, no) => {
      const i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = () => ok(i);
      i.onerror = no;
      i.src = abs(src) + (src.includes('?') ? '&' : '?') + 'ika=story';
    });
    const [pic, mark] = await Promise.all([load(v.img), p.logo ? load(p.logo).catch(() => null) : null]);
    const c = document.createElement('canvas');
    c.width = W;
    c.height = H;
    const x = c.getContext('2d');
    const spacing = (s) => { if ('letterSpacing' in x) x.letterSpacing = s; };
    const font = (px, w) => `${w || 400} ${px}px Helvetica, "Helvetica Neue", Arial, sans-serif`;
    const fit = (text, px, max) => {
      x.font = font(px);
      let t = String(text || '');
      while (t.length > 1 && x.measureText(t).width > max) t = t.slice(0, -2).trimEnd() + '…';
      return t;
    };

    // the same light grey as the product pictures in the shop
    x.fillStyle = '#f4f4f4';
    x.fillRect(0, 0, W, H);

    // brand left, designer right, below the space Instagram uses for its own bar
    x.fillStyle = '#111';
    x.font = font(28);
    spacing('3px');
    x.textAlign = 'left';
    x.fillText(String(p.vendor || '').toUpperCase(), M, 280);
    if (p.designer) {
      x.fillStyle = '#6f6f6f';
      x.textAlign = 'right';
      x.fillText(fit(String(p.designer).toUpperCase(), 28, 520), W - M, 280);
    }
    spacing('0px');

    // the chosen variant, whole, in a square; white in the picture turns into the grey behind it
    // 40 px lower than first drawn, so the piece sits more in the middle (Johannes, 2026-09-27)
    const box = { x: 180, y: 380, w: 720, h: 720 };
    const k = Math.min(box.w / pic.width, box.h / pic.height);
    const dw = pic.width * k, dh = pic.height * k;
    const dx = box.x + (box.w - dw) / 2, dy = box.y + (box.h - dh) / 2;
    x.drawImage(pic, dx, dy, dw, dh);
    x.globalCompositeOperation = 'multiply';
    x.fillStyle = '#f4f4f4';
    x.fillRect(dx, dy, dw, dh);
    x.globalCompositeOperation = 'source-over';

    // name (at most two lines), variant, price and where to get it: left-aligned like everything in the shop,
    // flush with the brand above, small and quiet
    x.textAlign = 'left';
    x.fillStyle = '#111';
    let px = 44;
    const wrap = () => {
      x.font = font(px);
      const lines = [];
      let line = '';
      for (const w of String(p.title).split(/\s+/)) {
        const t = line ? line + ' ' + w : w;
        if (x.measureText(t).width > W - 2 * M && line) {
          lines.push(line);
          line = w;
        } else line = t;
      }
      if (line) lines.push(line);
      return lines;
    };
    let lines = wrap();
    while (lines.length > 2 && px > 34) {
      px -= 2;
      lines = wrap();
    }
    lines = lines.slice(0, 2);
    let y = 1200;
    lines.forEach((l) => {
      x.fillText(l, M, y);
      y += Math.round(px * 1.18);
    });
    y += 4;
    x.font = font(28);
    if (v.title && v.title !== 'Default Title') {
      x.fillStyle = '#6f6f6f';
      x.fillText(fit(v.title, 28, W - 2 * M), M, y);
      y += 42;
    }
    x.fillStyle = '#111';
    x.fillText(v.price, M, y);
    y += 64;
    x.font = font(24);
    x.fillStyle = '#8a8a8a';
    spacing('1px');
    x.fillText(p.cta, M, y);
    spacing('0px');

    // free room for the link sticker, then the logo in black, centred, above Instagram's reply bar
    if (mark) {
      const lw = 260, lh = (mark.height / mark.width) * lw;
      const o = document.createElement('canvas');
      o.width = lw;
      o.height = lh;
      const ox = o.getContext('2d');
      ox.drawImage(mark, 0, 0, lw, lh);
      ox.globalCompositeOperation = 'source-in';
      ox.fillStyle = '#111';
      ox.fillRect(0, 0, lw, lh);
      x.drawImage(o, (W - lw) / 2, H - 260 - lh / 2);
    }
    return new Promise((ok) => c.toBlob(ok, 'image/jpeg', 0.92));
  };

  if (!data.variants || !data.variants.length) return;

  // the variant on screen: from the address (?variant=), else the product form
  const currentId = () => {
    const q = new URLSearchParams(location.search).get('variant');
    const f = document.querySelector('form.shopify-product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    return String(q || (f && f.value) || data.variants[0].id);
  };
  const variantOf = (id) => data.variants.find((v) => String(v.id) === id) || data.variants[0];
  const slug = (s) => String(s || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const made = new Map(); // variant id → picture file, or a promise of it (null when it could not be drawn)
  const prepare = (id) => {
    if (!made.has(id)) {
      const v = variantOf(id);
      const name = 'industrialkonzept-' + data.handle + (v.title && v.title !== 'Default Title' ? '-' + slug(v.title) : '') + '.jpg';
      made.set(id, draw(data, v)
        .then((blob) => {
          const f = blob ? new File([blob], name, { type: 'image/jpeg' }) : null;
          made.set(id, f);
          return f;
        })
        .catch(() => {
          made.set(id, null);
          return null;
        }));
    }
    return made.get(id);
  };

  // the button, in the row of product tools (ik-lab.js draws that row, so wait for it)
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ikl-tool';
  btn.setAttribute('data-ikp-share', '');
  const label = T('story.share');
  btn.innerHTML =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 15V3.5"></path><path d="M7.5 8 12 3.5 16.5 8"></path><path d="M5 11.5V20h14v-8.5"></path></svg><span></span>';
  const text = btn.querySelector('span');
  text.textContent = label;
  const say = (t, back) => {
    text.textContent = t;
    if (back) setTimeout(() => (text.textContent = label), 2500);
  };
  const place = () => {
    if (btn.isConnected) return true;
    const tools = document.querySelector('.ikl-tools');
    if (tools) {
      tools.insertBefore(btn, tools.querySelector('.ikl-unit'));
      return true;
    }
    return false;
  };
  if (!place()) {
    const mo = new MutationObserver(() => place() && mo.disconnect());
    mo.observe(document.body, { childList: true, subtree: true });
    // without the tools row: under the add to cart button
    setTimeout(() => {
      if (btn.isConnected) return;
      mo.disconnect();
      const atc = document.querySelector('.add-to-cart-container');
      if (atc) {
        const row = document.createElement('div');
        row.className = 'ikl-tools';
        row.appendChild(btn);
        atc.after(row);
      }
    }, 4000);
  }

  // made ahead (a phone only opens the share sheet straight after a tap): once the button is close to
  // the screen, when the pointer comes near, and after a variant change; nothing is drawn for visitors
  // who never get near the button
  let near = false;
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((en) => en.isIntersecting)) return;
      near = true;
      io.disconnect();
      prepare(currentId());
    }, { rootMargin: '300px' });
    const watch = () => (btn.isConnected ? io.observe(btn) : setTimeout(watch, 500));
    watch();
  } else setTimeout(() => prepare(currentId()), 2500);
  btn.addEventListener('pointerenter', () => prepare(currentId()));
  // the theme's picker uses buttons (no change event) and writes ?variant= into the address
  const afterChange = () => setTimeout(() => near && prepare(currentId()), 400);
  document.addEventListener('change', (e) => e.target.closest('form') && afterChange());
  document.addEventListener('click', (e) => e.target.closest('[role="option"][data-position]') && afterChange());

  const titleOf = (id) => {
    const v = variantOf(id);
    return data.vendor + ' – ' + data.title + (v.title && v.title !== 'Default Title' ? ', ' + v.title : '');
  };

  btn.addEventListener('click', async () => {
    const id = currentId();
    const url = new URL(data.url, location.origin);
    if (id !== String(data.variants[0].id) || location.search.includes('variant=')) url.searchParams.set('variant', id);
    const link = url.toString();
    let file = prepare(id);
    const phone = navigator.share && matchMedia('(pointer: coarse)').matches;
    if (phone) {
      // the sheet only opens straight after a tap: if the picture is not ready yet, wait and ask for a second tap
      if (file && !(file instanceof File)) {
        say(T('story.preparing'));
        await file;
        say(T('story.tap_to_share'));
        return;
      }
      const title = titleOf(id);
      const withPic = file instanceof File && navigator.canShare && navigator.canShare({ files: [file] });
      try {
        await navigator.share(withPic ? { files: [file], title, text: title + ' ' + link } : { title, url: link });
      } catch (e) {}
      say(label);
      return;
    }
    if (file && !(file instanceof File)) {
      say(T('story.preparing'));
      file = await file;
      say(label);
    }
    if (file instanceof File && window.ikStoryPreview) window.ikStoryPreview(file, link, data.title, variantOf(id).title !== 'Default Title' ? variantOf(id).title : '');
    else if (file instanceof File) {
      // without the shared window (ik-lab.js): download as before
      const a = document.createElement('a');
      a.href = URL.createObjectURL(file);
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    else {
      // the picture could not be drawn: at least the link
      const ok = navigator.clipboard ? await navigator.clipboard.writeText(link).then(() => true, () => false) : false;
      if (ok) say(T('story.link_copied'), true);
    }
  });
})();
